import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10 5h4a3 3 0 1 1 6 0 2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2 3 3 0 0 1 6 0m7-1a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1M8 5a1 1 0 0 0-2 0v2a1 1 0 0 0 2 0zm12 6H4v8h16z",
      clipRule: "evenodd"
    }
  )
);
var SvgCalendarFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CalendarFilled_default = SvgCalendarFilled;

export { CalendarFilled_default as default };
